<template>
  <v-card class="ma-4">
    <v-card-title>
      Wyniki szkoleń
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Wyszukaj" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="courseResults.items"
      item-key="id"
      :options.sync="options"
      :server-items-length="courseResults.count"
      :loading="courseResults.loading"
      :footer-props="{
        'items-per-page-text': 'Ilość elementów na stronę:',
        'items-per-page-all-text': 'Wszystkie',
        'page-text': '{0}-{1} z {2}'
      }"
      :no-data-text="search ? 'Brak wyników szkolenia z podanym filtrem' : 'Brak wyników szkolenia'"
      no-results-text="Brak wyników szkolenia z podanym filtrem"
      loading-text="Ładowanie... Proszę czekać"
      disable-sort
      class="elevation-1"
    >
      <template v-slot:item.started="{ item }">
        {{ item.started | date }}
      </template>
      <template v-slot:item.finished="{ item }">
        {{ item.finished | date }}
      </template>
      <template v-slot:item.score="{ item }">
        {{ item.score === null ? '-' : `${item.score}%` }}
      </template>
      <template v-slot:item.result="{ item }">
        {{ item.result === 0 ? 'Nie przystąpił/-a' : item.result === 1 ? 'Nie ukończono' : 'Zakończył/-a' }}
      </template>
      <template v-slot:item.state="{ item }">
        {{ item.state === 0 ? 'Nie rozpoczęto' : item.state === 1 ? 'W trakcie' : 'Zakończono' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <ResetUserCourseResultsModal
          v-if="item.courseExecutionId"
          :user="item"
          :course="course"
          :group="group"
          :options="{ ...options, search }"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ResetUserCourseResultsModal from '@/components/manage/groups/manage-group/assigned-courses/ResetUserCourseResultsModal.vue';

const { mapActions, mapState } = createNamespacedHelpers('groups');
const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  components: {
    ResetUserCourseResultsModal
  },
  props: {
    course: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      search: null,
      options: {},
      expanded: []
    };
  },
  computed: {
    ...mapState({
      courseResults: state => state.groupAssignment.courseResults
    }),
    ...mapAccountState(['token']),
    headers() {
      return [
        { text: 'Imię', value: 'name' },
        { text: 'Nazwisko', value: 'surname' },
        { text: 'Email', value: 'email' },
        { text: 'Ropoczęto', value: 'started' },
        { text: 'Zakończono', value: 'finished' },
        { text: 'Ilość punktów', value: 'score' },
        { text: 'Wynik', value: 'result' }, // NotAttempted, Incomplete, Completed
        { text: 'Status', value: 'state' }, // Scheduled, InProgress, Finished
        { text: 'Akcje', value: 'actions' }
      ];
    }
  },
  watch: {
    search(val) {
      this.options.page = 1;
      this.getCourseResults({
        groupId: this.group.id,
        courseId: this.course.courseId,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        search: val
      });
    },
    options: {
      handler(val) {
        this.getCourseResults({
          groupId: this.group.id,
          courseId: this.course.courseId,
          page: val.page,
          itemsPerPage: val.itemsPerPage,
          search: this.search
        });
      },
      deep: true
    }
  },
  methods: mapActions(['getCourseResults'])
};
</script>

<style lang="scss" scoped></style>
